module.exports = __webpack_public_path__ + "img/progress_015.a616aa6b.png";